import api from '../baseApi.js'
import { byName, unwrap } from '../helpers.js'

export const examsApi = {
  getAll: (params) => api.get('/exams', { params }).then(unwrap).then(byName),
  getOne: (id) => api.get(`/exams/${id}`).then(unwrap),
  create: (data) => api.post('/exams', data).then(unwrap),
  update: (id, data) => api.put(`/exams/${id}`, data).then(unwrap),
  remove: (id) => api.delete(`/exams/${id}`).then(unwrap),
  getResultSheet: (id) => api.get(`/exams/${id}/result-sheet`).then(unwrap),
  bulkResults: (id, data) => api.post(`/exams/${id}/results/bulk`, data).then(unwrap),
  publishResults: (id, data) => api.post(`/exams/${id}/results/publish`, data || {}).then(unwrap),
}
